import { forwardRef } from 'react';

import { MenuTrigger } from '../menu/menu-trigger';
import { propertyCardMenuTriggerStyles } from './styles/property-card-menu-trigger.styles';
import type { PropertyCardMenuTriggerPropsInterface } from './types/property-card-menu-trigger.types';

/**
 * A custom menu trigger used by `PropertyCard` to show a menu of actions.
 *
 * @since 8.63.0
 */
export const PropertyCardMenuTrigger = forwardRef<
  HTMLButtonElement,
  PropertyCardMenuTriggerPropsInterface
>((props: PropertyCardMenuTriggerPropsInterface, forwardedRef) => {
  const { css: cssProp, ...rest } = props;

  return (
    <MenuTrigger
      ref={forwardedRef}
      data-c11n-component="PropertyCard.MenuTrigger"
      data-c11n-version={__C11N_VERSION__}
      css={{ ...propertyCardMenuTriggerStyles, ...cssProp }}
      {...rest}
    />
  );
});

PropertyCardMenuTrigger.displayName = 'PropertyCard.MenuTrigger';
